import React, { useState } from 'react';
import styles from './SecurityLogs.module.css';

// Import existing Security Dashboard components
import Deliveries from '../../SecurityDashboard/Deliveries/Deliveries';
import GatePass from '../../SecurityDashboard/GatePass/GatePass';
import Patrolling from '../../SecurityDashboard/Patrolling/Patrolling';
import Incidents from '../../SecurityDashboard/Incidents/Incidents';
import SocietyGates from './SocietyGates';
import Visitors from '../Visitors/Visitors';
import Attendance from '../../SecurityDashboard/Attendance/Attendance';

const SecurityLogs = () => {
  const [activeTab, setActiveTab] = useState('Deliveries');

  const tabs = [
    { id: 'Visitors', label: 'Visitor Logs', component: <Visitors /> },
    { id: 'Deliveries', label: 'Deliveries & Couriers', component: <Deliveries /> },
    { id: 'GatePass', label: 'Gate Passes', component: <GatePass /> },
    { id: 'Patrolling', label: 'Patrolling Logs', component: <Patrolling /> },
    { id: 'Incidents', label: 'Incidents', component: <Incidents /> },
    { id: 'Gates', label: 'Society Gate', component: <SocietyGates /> },
    { id: 'Attendance', label: 'Worker Attendance', component: <Attendance /> }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <h1>Security Guard Activity Logs</h1>
        <p>Monitor all activities, logs, and updates managed by the security team</p>
      </div>

      <div className={styles.tabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabBtn} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {/* We wrap the child component in a div to prevent its own .container padding from adding too much whitespace, since Admin already has padding. */}
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default SecurityLogs;
